import * as signalR from '@microsoft/signalr';
import { useEffect, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { API_SERVER } from '../utils/constants';

export const useDeviceSignalR = () => {
  const queryClient = useQueryClient();
  const connectionRef = useRef(null);

  useEffect(() => {
    let token = localStorage.getItem('accessToken');
    if (!token) return;

    if (connectionRef.current) {
      return;
    }

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_SERVER}/hub?topics=devices`, {
        accessTokenFactory: () => token,
        transport:
          signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.LongPolling,
        withCredentials: true,
      })
      .withHubProtocol(new signalR.JsonHubProtocol())
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    connectionRef.current = connection;

    connection
      .start()
      .catch(err => console.error('❌ SignalR bağlantı hatası:', err));

    connection.on('ReceiveDevice', rawData => {
      let parsedData;
      try {
        // JSON string mi? Parse et
        if (typeof rawData === 'string') {
          parsedData = JSON.parse(rawData);
        } else {
          parsedData = rawData;
        }

        // Gelen veri tek obje mi? Array'e çevir
        if (!Array.isArray(parsedData)) {
          console.warn(
            '🚨 SignalR Data is not an array, converting to array:',
            parsedData
          );
          parsedData = [parsedData];
        }

        queryClient.setQueryData('dataKey', prevData => {
          const updatedData = prevData
            ? prevData.map(device =>
                parsedData.some(d => d.id === device.id)
                  ? parsedData.find(d => d.id === device.id)
                  : device
              )
            : [...parsedData];

          return updatedData;
        });

      } catch (error) {
        console.error('❌ JSON parse hatası:', error);
      }
    });

    return () => {
      connection.off('ReceiveDevice');
      connection.stop();
      connectionRef.current = null;
    };
  }, [queryClient]);
};
